import { CustomFieldParams } from "@/types/customFieldTypes";
import { CustomField } from "./customField";

export class ValidationCustomField extends CustomField {
  result: boolean;
  message: string;

  constructor(data: CustomFieldParams) {
    super(data);
    this.customValue = data.customValue === 'true' || data.customValue === true;
    this.result = this.customValue;
    this.message = String(data.defaultValue);
  }

  hasValidDefaultInput() { return true; }

  hasValidCustomInput() { return true; }
}
